import axios from "axios"
import helper from "helpers/fn_helper"

const baseUrl = process.env.REACT_APP_BACKEND_URL

const authHeaders = () => ({
  authorization: helper.Auth.getToken(),
})

export async function UploadFileToS3({
  file,
  folder = "line-campaign",
  fileName = "",
  onProgress = null,
  abortController = null,
  onUploadIdGenerated = null,
}) {
  if (!file) {
    return { success: false, error: "No file provided" }
  }

  const formData = new FormData()
  formData.append("file", file, fileName || file.name)

  const params = new URLSearchParams({ folder })
  if (fileName) params.set("filename", fileName)

  try {
    if (typeof onUploadIdGenerated === "function") {
      onUploadIdGenerated("api-proxy")
    }

    const response = await axios.post(
      `${baseUrl}/upload?${params.toString()}`,
      formData,
      {
        headers: authHeaders(),
        signal: abortController?.signal,
        timeout: 120000,
        onUploadProgress: event => {
          if (!onProgress || !event.total) return
          onProgress(Math.round((event.loaded * 100) / event.total))
        },
      }
    )
    if (typeof onProgress === "function") onProgress(100)

    const url = response.data?.data?.url
    if (!url) throw new Error("Upload API returned no URL")

    return {
      success: true,
      url,
      key: response.data?.data?.key,
    }
  } catch (error) {
    const aborted =
      abortController?.signal?.aborted ||
      axios.isCancel(error) ||
      error?.name === "CanceledError"

    return {
      success: false,
      aborted,
      error: aborted
        ? "Upload aborted by user"
        : error?.response?.data?.message || "Failed to upload file",
    }
  }
}

export async function DeleteFileFromS3({ fileUrl, directKey = null }) {
  try {
    const response = await axios.delete(`${baseUrl}/upload`, {
      data: {
        fileUrl,
        key: directKey,
      },
      headers: authHeaders(),
      timeout: 20000,
    })

    return {
      success: true,
      key: response.data?.data?.key,
    }
  } catch (error) {
    return {
      success: false,
      error: error?.response?.data?.message || "Failed to delete file",
    }
  }
}
